// Re-export UUIDs from types for convenience
export {
  BLE_SERVICE_UUID,
  CHAR_ALERT_UUID,
  CHAR_SPECTRUM_UUID,
  CHAR_DEVICES_UUID,
} from '../types/ble';

/** Number of nRF24 channels (2400-2525 MHz) */
export const NUM_CHANNELS = 126;

/** Base frequency in MHz */
export const BASE_FREQ_MHZ = 2400;

/** Max power value from firmware (NRF_SAMPLES_PER_CH) */
export const MAX_POWER = 2;

/** WiFi channel center frequencies (MHz) */
export const WIFI_CHANNELS: Record<number, number> = {
  1: 2412,
  2: 2417,
  3: 2422,
  4: 2427,
  5: 2432,
  6: 2437,
  7: 2442,
  8: 2447,
  9: 2452,
  10: 2457,
  11: 2462,
  12: 2467,
  13: 2472,
};

/** WiFi channels to show as markers (US standard) */
export const WIFI_MARKER_CHANNELS = [1, 6, 11] as const;

/** Convert nRF24 channel index to frequency MHz */
export function channelToFreq(ch: number): number {
  return BASE_FREQ_MHZ + ch;
}

/** Convert frequency MHz to nRF24 channel index */
export function freqToChannel(freq: number): number {
  return freq - BASE_FREQ_MHZ;
}

/** Waterfall history depth (number of rows) */
export const WATERFALL_DEPTH = 256;

/** Spectrum poll interval from firmware (ms) */
export const SPECTRUM_POLL_MS = 200;

/** Target render FPS */
export const TARGET_FPS = 60;

/** Reconnection config */
export const RECONNECT_BASE_MS = 1000;
export const RECONNECT_MAX_MS = 30000;
export const RECONNECT_FACTOR = 2;
export const RECONNECT_JITTER = 0.2;

/** IndexedDB config */
export const DB_NAME = 'sentinel';
export const DB_VERSION = 1;
export const ALERT_STORE = 'alerts';
export const DEVICE_STORE = 'knownDevices';
export const BASELINE_STORE = 'baselines';
export const MAX_ALERTS = 10000;

/** Color palette for instrument UI */
export const COLORS = {
  scopeBg: '#0a0a0a',
  scopeGrid: '#1a2a1a',
  scopeTrace: '#00ff88',
  scopeTraceDim: '#006633',
  scopePeak: '#ff3333',
  scopeMarker: '#ffaa00',
  scopeInfo: '#00ccff',
  severityCrit: '#ff2222',
  severityHigh: '#ff6600',
  severityMed: '#ffaa00',
  severityLow: '#00ccff',
} as const;
